module.exports = "<div class=\"cm-editor v2\">\n  <ng-include src=\"'angularModules/admin/locations/editor/locationEditorForm.html'\" />\n</div>\n"